import React, { Fragment, useState, useEffect } from "react";
import { Redirect } from "react-router-dom";

import AppBar from "@material-ui/core/AppBar";
import Grid from "@material-ui/core/Grid";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import { ExitToAppSharp } from "@material-ui/icons";

import IconButton from "@material-ui/core/IconButton";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import Tooltip from "@material-ui/core/Tooltip";
import Hidden from "@material-ui/core/Hidden";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  toolbar: {
    background: "linear-gradient(60deg, #000000 , #232321)",
    boxShadow:
      "0 4px 20px 0 rgba(0, 0, 0,.14), 0 7px 10px -5px rgba(0, 0, 0,.4)",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  imgLogo: {
    backgroundImage: "url(../../images/log-goubi.png)",
    height: "50px",
    backgroundRepeat: "no-repeat",
    backgroundSize: "40px 40px",
    backgroundPosition: "left",
    marginLeft: "35px",
  },
  textNameUser: {
    padding: "5px",
    fontFamily: '"Yanone Kaffeesatz", Sans-serif',
    letterSpacing: "1.5px",
    fontWeight: "600",
    textDecoration: "none",
    color: "#F7F00B",
    margin: "1% 5% ",
    position: "absolute",
  },
  textLogout: {
    padding: "5px",
    fontFamily: '"Yanone Kaffeesatz", Sans-serif',
    letterSpacing: "1.5px",
    fontWeight: "600",
    textDecoration: "none",
    color: "#F7F00B",
    marginRight: "35px",
    marginTop: "1%",
  },
}));

export default function Header(props) {
  const classes = useStyles();

  const [exit, setExit] = useState(false);
  const [names, setNames] = useState(null);
  let login = localStorage.getItem("token") == null ? false : true;
  let user_name = props.changeNameUser;

  useEffect(() => {
    if (user_name === undefined) {
      setNames("Por favor, cerrar sesión al terminar.");
    } else {
      setNames("Hola, " + user_name);
    }
  }, []);

  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleExit = () => {
    setOpenBackdrop(true);

    setTimeout(() => {
      //localStorage.removeItem("token");
      localStorage.clear();
      setExit(true);
    }, 1000);
  };

  if (exit) {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          <Grid item xs={9} sm={9}>
            <div className={classes.imgLogo}>
              <Typography
                align="left"
                variant="subtitle2"
                className={classes.textNameUser}
              >
                <Hidden only="xs">{login ? names : ""}</Hidden>
              </Typography>
            </div>
          </Grid>

          <Grid item xs={3} sm={3}>
            <Typography
              align="right"
              variant="subtitle2"
              className={classes.textLogout}
            >
              {login ? "Salir" : ""}
              <Tooltip title="Cerrar sesión" aria-label="Cerrar sesión">
                <IconButton
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleMenu}
                  color="inherit"
                >
                  {login ? <ExitToAppSharp /> : ""}
                </IconButton>
              </Tooltip>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={open}
                onClose={handleClose}
              >
                <MenuItem onClick={handleExit}>Cerrar sesión</MenuItem>
              </Menu>
            </Typography>
          </Grid>
        </Toolbar>
      </AppBar>
      <Toolbar id="back-to-top-anchor" />
      <Backdrop
        style={{ zIndex: "9999", color: "#FFFFFF" }}
        open={openBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Fragment>
  );
}
